import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as pbi from 'powerbi-client';
import { service as PBIService, IEmbedConfiguration, Embed, models } from 'powerbi-client';
import { IpBIReport } from '../pages/report-landing/_entities/pbiReport.model';
import { IEmbedConfig } from '../pages/report-landing/_entities/embedConfig.model';
import { ActivatedRoute } from '@angular/router';
import { ReportLandingService } from '../pages/report-landing/_service/report-landing.service';

@Component({
  selector: 'app-foreman-powerbi-report',
  templateUrl: './foreman-powerbi-report.component.html',
  styleUrls: ['./foreman-powerbi-report.component.css']
})
export class ForemanPowerbiReportComponent implements OnInit {
  eConfig: IEmbedConfig = {
    username: '', embedToken: { expiration: new Date(), token: '', tokenId: '' },
    embedUrl: '', enableRLS: false, errorMessage: '', id: '', isEffectiveIdentityRequired: false,
    isEffectiveIdentityRolesRequired: false, minutesToExpiration: 0, roles: '', dashboardId: ''
  };
  showrptcontainer: boolean;
  @ViewChild('reportContainer') reportContainer: ElementRef;
  public screenHeight: number;
  public screenWidth: number;
  constructor(private router : ActivatedRoute,private _rptlanding: ReportLandingService ) { }

  ngOnInit() {
    this.screenHeight = (window.screen.height);
    this.screenWidth = (window.screen.width);
    const userId =this.router.snapshot.params.id;

    this.embedReportDetails(userId);
    // this.showReport();
  }

  embedReportDetails(userId)
  {
    this._rptlanding.getProjectsdetailsFrReport(userId).subscribe((data) => {
      if (data) {
        this.eConfig = data;
        this.showrptcontainer = true;
    const pconfig: pbi.IEmbedConfiguration = {
      accessToken: this.eConfig.embedToken.token,
      type: 'report', // pbi.models.TokenType.Embed.toString(),
      tokenType: models.TokenType.Embed,
      embedUrl: this.eConfig.embedUrl, // Report URl
      id: this.eConfig.id,
      uniqueId: '',
      permissions: pbi.models.Permissions.All,
      pageView: "fitToWidth", 
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true,
        
        //layoutType: models.LayoutType.MobileLandscape
      }
    };
    // Grab the reference to the div HTML element that will host the report.
    const reportContainer = <HTMLElement>document.getElementById('reportContainer');
    // Embed the report and display it within the div container.
    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    powerbi.reset(reportContainer);
    // let report = powerbi.embed(reportContainer, pconfig);
    const report = powerbi.embed(reportContainer, pconfig);
    // Report.off removes a given event handler if it exists.
    report.off('loaded');
    // Report.on will add an event handler which prints to Log window.
    report.on('loaded', function () {
      console.log('Loaded');
    });
    // Report.off removes a given event handler if it exists.
    report.off('loaded');
    // Report.on will add an event handler which prints to Log window.
  }
    });

  }
}
